/*
 * product (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { products } from "./product.schema"

/* Select */
export type Product = z.infer<typeof selectProductSchema>
export const selectProductSchema = createSelectSchema(products)

/* Filters */
export type ProductFilters = z.infer<typeof productFiltersSchema>
export const productFiltersSchema = z.object({
	id: z.string().optional(),
	producerId: z.string().optional(),
	productType: z.number().optional(),
	discontinued: z.boolean().optional(),
	currentlyUnavailable: z.boolean().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createProductSchema = createInsertSchema(products).partial(globalCreateExclude)
export type CreateProduct = z.infer<typeof createProductSchema>

/* Update */
export const updateProductSchema = createInsertSchema(products)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdateProduct = z.infer<typeof updateProductSchema>
